import React from "react";
import PropTypes from "prop-types";

const AssetsTable = ({
  assets = [
    {
      id: "NVDA",
      name: "NVDA",
      symbol: "NVDA",
      company: "NVIDIA Corporation",
      weight: "20.00%",
      sharePrice: "$875.28",
      value: "$175,056",
      shares: "200",
      strategies: ["Growth", "Tech"],
      logo: "https://logo.clearbit.com/nvidia.com",
    },
    {
      id: "AAPL",
      name: "AAPL",
      company: "Apple Inc.",
      weight: "18.00%",
      sharePrice: "$34.52",
      value: "$10,500.00",
      shares: "72 shares",
      strategies: ["Strategy A"],
      logo: "https://logo.clearbit.com/apple.com",
    },
    {
      id: "AMZN",
      name: "AMZN",
      company: "Amazon.com",
      weight: "15.00%",
      sharePrice: "$78.93",
      value: "$9,600.00",
      shares: "3 shares",
      strategies: ["Strategy A", "Strategy B"],
      logo: "https://logo.clearbit.com/amazon.com",
    },
    {
      id: "MA",
      name: "MA",
      company: "Mastercard",
      weight: "14.00%",
      sharePrice: "$120.37",
      value: "$14,000.00",
      shares: "5 shares",
      strategies: ["Strategy A", "Strategy B", "Strategy C"],
      logo: "https://logo.clearbit.com/mastercard.com",
    },
    {
      id: "MSFT",
      name: "MSFT",
      company: "Microsoft Corp.",
      weight: "12.00%",
      sharePrice: "$45.66",
      value: "$8,800.00",
      shares: "30 shares",
      strategies: ["Strategy B"],
      logo: "https://logo.clearbit.com/microsoft.com",
    },
    {
      id: "TSLA",
      name: "TSLA",
      company: "Tesla Inc.",
      weight: "10.00%",
      sharePrice: "$69.74",
      value: "$14,000.00",
      shares: "20 shares",
      strategies: ["Strategy B", "Strategy C"],
      logo: "https://logo.clearbit.com/tesla.com",
    },
    {
      id: "V",
      name: "V",
      company: "Visa",
      weight: "8.00%",
      sharePrice: "$30.23",
      value: "$6,600.00",
      shares: "20 shares",
      strategies: ["Strategy B"],
      logo: "https://logo.clearbit.com/visa.com",
    },
    {
      id: "NFLX",
      name: "NFLX",
      company: "Netflix Inc.",
      weight: "3.00%",
      sharePrice: "$65.47",
      value: "$5,000.00",
      shares: "10 shares",
      strategies: ["Strategy C"],
      logo: "https://logo.clearbit.com/netflix.com",
    },
  ],
  containerStyle = {},
}) => {
  const renderAssetLogo = (asset) => {
    const logoStyle = {
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: "600",
      color: "#ffffff",
      marginRight: "12px",
      flexShrink: 0,
    };

    const colorMap = {
      NVDA: "#10b981",
      AAPL: "#000000",
      AMZN: "#ff9900",
      MA: "#eb001b",
      MSFT: "#00a1f1",
      TSLA: "#cc0000",
      V: "#1a1f71",
      NFLX: "#e50914",
    };

    const assetSymbol = asset.symbol || asset.name || asset.id || "N/A";

    return (
      <div
        style={{
          ...logoStyle,
          backgroundColor: colorMap[assetSymbol] || "#6b7280",
        }}
      >
        {assetSymbol.charAt(0)}
      </div>
    );
  };

  const renderStrategies = (strategies) => {
    return (
      <div
        style={{
          fontSize: "14px",
          color: "#64748b",
          fontWeight: "400",
          letterSpacing: "0.01em",
        }}
      >
        {strategies.join(", ")}
      </div>
    );
  };

  return (
    <div
      style={{
        marginTop: "1rem",
        marginLeft: "-1.5rem",
        marginRight: "-1.5rem",
        marginBottom: "-1.5rem",
        paddingBottom: "1.5rem",
        backgroundColor: "white",
        borderRadius: "0",
        border: "none",
        overflow: "visible",
        width: "calc(100% + 3rem)",
        ...containerStyle,
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #e2e8f0",
          display: "grid",
          gridTemplateColumns:
            "minmax(180px, 2fr) minmax(80px, 1fr) minmax(90px, 1fr) minmax(120px, 1.2fr) minmax(100px, 1.2fr)",
          gap: "0.5rem",
          padding: "12px 1.5rem",
          fontSize: "12px",
          fontWeight: "500",
          color: "#64748b",
          textTransform: "none",
          letterSpacing: "0.02em",
          minWidth: "600px",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>Assets</div>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          Weight
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#64748b"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ opacity: 0.7 }}
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>Share price</div>
        <div style={{ display: "flex", alignItems: "center" }}>Value</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          From strategy
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        {assets.map((asset, index) => (
          <div
            key={asset.id}
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(180px, 2fr) minmax(80px, 1fr) minmax(90px, 1fr) minmax(120px, 1.2fr) minmax(100px, 1.2fr)",
              gap: "0.5rem",
              padding: "14px 1.5rem",
              borderBottom:
                index < assets.length - 1
                  ? "1px solid #f1f5f9"
                  : "1px solid #e5e7eb",
              fontSize: "15px",
              color: "#334155",
              minWidth: "600px",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              backgroundColor: index % 2 === 0 ? "#ffffff" : "#fafbfc",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {renderAssetLogo(asset)}
              <div>
                <div
                  style={{
                    fontWeight: "400",
                    marginBottom: "1px",
                    fontSize: "14px",
                    color: "#0f172a",
                    letterSpacing: "0.01em",
                  }}
                >
                  {asset.symbol || asset.name || asset.id || "N/A"}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    fontWeight: "400",
                    letterSpacing: "0.01em",
                  }}
                >
                  {asset.company}
                </div>
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontWeight: "400",
                  color: "#0f172a",
                  fontSize: "14px",
                  letterSpacing: "0.01em",
                }}
              >
                {asset.weight}
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontWeight: "400",
                  color: "#0f172a",
                  fontSize: "14px",
                  letterSpacing: "0.01em",
                }}
              >
                {asset.sharePrice}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontWeight: "400",
                  color: "#0f172a",
                  fontSize: "14px",
                  letterSpacing: "0.01em",
                  marginBottom: "1px",
                }}
              >
                {asset.value}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  fontWeight: "400",
                  letterSpacing: "0.01em",
                }}
              >
                {asset.shares} shares
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              {renderStrategies(asset.strategies)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

AssetsTable.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      company: PropTypes.string.isRequired,
      weight: PropTypes.string.isRequired,
      sharePrice: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      shares: PropTypes.string.isRequired,
      strategies: PropTypes.arrayOf(PropTypes.string).isRequired,
      logo: PropTypes.string,
    })
  ),
  containerStyle: PropTypes.object,
};

export default AssetsTable;
